import * as $http from 'axios'

export default {
    createNTS: payloads => $http.post('v2/net_trust_scores', payloads),
    updateNTS: (id, payloads) => $http.put(`v2/net_trust_scores/${id}`, payloads),
}
